
document.addEventListener('DOMContentLoaded', function(event) {
    
	const tabbed_content_blocks = document.querySelectorAll('.wp-block-crown-blocks-tabbed-content');
	
	/**
	 * Update tab state on tab click
	 */
	const tabbed_content_tabs = document.querySelectorAll('.wp-block-crown-blocks-tabbed-content .tabs .tab');
	tabbed_content_tabs.forEach( (tab, index) => {
		tab.addEventListener('click', e => {

			if ( tab.classList.contains('active') ) return;
			
			tabbed_content_tabs.forEach(a => a.classList.remove('active'));
			tab.classList.add('active');
			
			let tabbed_content_block = tab.closest('.wp-block-crown-blocks-tabbed-content');
			let block_panels = tabbed_content_block.querySelectorAll('.panels > .panel');
			block_panels.forEach( panel => panel.classList.remove('active') );
			block_panels[index].classList.add('active');
			
		}, true);
	});

	/**
	 * Update tab state on select input change 
	 */
	const tabbed_content_select_inputs = document.querySelectorAll('.wp-block-crown-blocks-tabbed-content .tabs-select');
	tabbed_content_select_inputs.forEach( (select_input, index) => {
		select_input.addEventListener('change', e => {
			
			let tab_number = parseInt( e.target.value, 10 );
			
			let tabbed_content_block = select_input.closest('.wp-block-crown-blocks-tabbed-content');
			let tabbed_content_tabs = tabbed_content_block.querySelectorAll('.tab');
			let block_panels = tabbed_content_block.querySelectorAll('.panels > .panel');

			tabbed_content_tabs.forEach(a => a.classList.remove('active'));
			tabbed_content_tabs[tab_number].classList.add('active');
			
			block_panels.forEach( panel => {
				panel.style.display = 'none';
			});
			block_panels[tab_number].style.display = 'block';

			
		}, true);
	});

	const params = new URLSearchParams(window.location.search);
	const tcs = params.get('tcs');
	
	tabbed_content_blocks.forEach( block => {
		let tabs = block.querySelectorAll('.tabs .tab');
		let panels = block.querySelectorAll('.panels .wp-block-crown-blocks-tabbed-content-tab');

		const blockNumber = block.getAttribute('data-block-number');
		let tabNumber = false;

		if ( typeof tcs !== 'undefined' && tcs != null && tcs != '' ) {
			const tcs_numbers = tcs.split('-');

			tcs_numbers.forEach( (value, index) => {
				const tcs_pieces = value.split(',');
				let tcsBlockNumber = tcs_pieces[0];
				let tcsTabNumber = tcs_pieces[1];

				if ( tcsBlockNumber == blockNumber ) {
					tabNumber = tcsTabNumber;
				}
			});
		}

		if ( tabNumber ) {
			const tcsTabNumber = ( parseInt( tabNumber, 10 ) - 1 ); // convert to int and subtract 1 for 0-indexed arrays

			// remove active class from all tabs and add to requested tab
			tabs.forEach( tab => tab.classList.remove('active') );
			tabs[tcsTabNumber].classList.add('active');

			// add display block to requested panel
			panels[tcsTabNumber].classList.add('active');
		} else {
			panels[0].classList.add('active');
		}
	});
	
});
